import React from "react";
import "./CustomSlider.css";

function CustomSlider({ value, onChange, min, max }) {
  return (
    <div className="slidecontainer">
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        className="slider"
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="value">{value}</p>
    </div>
  );
}

export default CustomSlider;
